import { render, staticRenderFns } from "./EducationSolution.vue?vue&type=template&id=43f2040b&"
import script from "./EducationSolution.vue?vue&type=script&lang=js&"
export * from "./EducationSolution.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports